<template>
    <div v-if="cargo" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Cargo de Funcionário</h4>
        <router-link to="/cadastros/cargos-funcionarios">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <!-- Seção de Detalhes -->
        <FormSection title="">
          <p><strong>Nome:</strong> {{ cargo.nome || 'Não informado' }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        cargo: null,
      };
    },
    methods: {
      async carregarDetalhesCargo() {
        try {
          const response = await axios.get(
            `/cadastros/cargos-funcionarios/${this.$route.params.id}`
          );
          this.cargo = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes do cargo:", error);
        }
      },
    },
    mounted() {
      this.carregarDetalhesCargo();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  